export const DEFERRED_SYMBOL = Symbol('deferred')

/**
 * deferredActionDispatch: {
 *   type: String
 *   payload: any,
 *   [DEFERRED_SYMBOL]: Boolean
 * }
 * dispatch<Rromise>(action: deferredActionDispatch)
 */
const deferredActionDispatch = _ => next => action => {
  if (!action[DEFERRED_SYMBOL]) return next(action)

  return new Promise((resolve, reject) => {
    action[DEFERRED_SYMBOL] = {
      resolve,
      reject
    }
    next(action)
  })
}
export default deferredActionDispatch
